import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@collaborate-health/uikit'
import { TenantResponse, UserResponse } from '@tabeeb/contracts/main-api/swagger-main-api'

import { CertificatesDisplayType } from '../../constants'

import CertificatesGrid from '../CertificatesGrid'

export interface ContractorUserCertificatesDialogProps {
  open: boolean
  user: UserResponse
  sourceTenant?: TenantResponse
  onClose: () => void
}

const ContractorUserCertificatesDialog: React.FC<ContractorUserCertificatesDialogProps> = ({
  open,
  user,
  sourceTenant,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth='lg'
      TransitionProps={{ unmountOnExit: true }}
      height='70vh'
    >
      <DialogTitle>User certificates</DialogTitle>

      <DialogContent>
        <CertificatesGrid
          simpleView
          user={user}
          contractorSourceTenantId={sourceTenant?.Id}
          displayType={CertificatesDisplayType.ContractUser}
        />
      </DialogContent>

      <DialogActions>
        <Button color='primary' onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ContractorUserCertificatesDialog

